<template>
  <div v-if="checked" class="un-login-distributeShop">
    <div class="block-header">
      <div class="part-logo">
        <img src="@/assets/logo_orange.png" />
        快麦通
      </div>
      <div class="login-btn">
        <el-button type="primary" @click="handleLogin">立即登录</el-button>
      </div>
    </div>
    <div class="block-body">
      <!-- <div class="block-body-left">
      </div> -->
      <div class="block-body-main">
        <SupplierInfo @login="handleLogin"/>
      </div>
    </div>
    <LoginDialog ref="loginDialog" @registe="handleRegiste"/>
    <RegisteDialog ref="registeDialog"  @login="handleLogin"/>
  </div>
</template>

<script>
import '@/assets/css/distributor.scss';
import SupplierInfo from '@/pages/unLogin/distributeShop/supplierInfo'
import LoginDialog from '@pages/unLogin/distributeShop/loginDialog/index.vue'
import RegisteDialog from '@pages/unLogin/distributeShop/loginDialog/registe.vue'
import { mapActions, mapGetters } from "vuex";
import {loadUserInfo, switchIdentity} from '@/pages/login/servers'

export default {
  provide: {
    unLogin: true  // 是否登录
  },
  components: {
    SupplierInfo,
    LoginDialog,
    RegisteDialog
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    $route: {
     async handler(val) {
        let id = val.query?.supplierId
        if (!id) return;
        await this.fetch_shareCompanyInfo({id})
        let isSelfCode = await this.checkIsSelf(id)
        let isOtherCode = await this.checkIsOther(id)

        const supplierId = val.query.supplierId
        const bindRelationUrlMap = {
          '11': '/supplier/commodity/myShop',
          '12': `/supplier/commodity/myShop?isMy=${true}`,
          '22': `/distributor/supplier/info?supplierId=${supplierId}`,
          '21': `/distributor/supplier/info?supplierId=${supplierId}`
        }
        if(this.shareCompanyInfo && this.shareCompanyInfo.type && this.shareCompanyInfo.type !== '0') {
          if (isSelfCode === '0' || isOtherCode === '0') {
            return;
          }
          this.$router.push(bindRelationUrlMap[isSelfCode || isOtherCode || this.shareCompanyInfo.type])
        }
        setTimeout(() => {
          this.checked = true;
        }, 1000);
      },
      deep: true,
      immediate: true
    },
  },
  computed:{
    ...mapGetters(['shareCompanyInfo'])
  },
  mounted() {
    this.$change_color('#2695FA')
  },
  methods: {
    ...mapActions(['fetch_shareCompanyInfo']),
    // 看看是不是自己访问邀请链接
    // 如果当前访问的supplierId和登录者是同一用户，且用户状态是分销商，那么需要切换成供销商，并且返回去自己小店页面的标识
    async checkIsSelf(supplierId) {
      const userInfo = this.$store.getters.userInfo;
      if (!userInfo) {
        return false
      }
      if (userInfo.companyId === Number(supplierId)) {
        if (userInfo.loginIdentity === 2) {
          // 分销商身份需要切换成供销商
          const success = await switchIdentity(1);
          const success2 = await loadUserInfo()
          if (success && success2) {
            return '11'
          } else {
            return '0'
          }
        }
        return '11'
      } else {
        return false
      }
    },
    // 看看是不是其他人访问邀请链接
    // 如果当前访问的supplierId和登录者不是同一用户，且用户状态是供销商，那么需要切换成分销商，并且返回去选款页面的标识
    async checkIsOther(supplierId) {
      const userInfo = this.$store.getters.userInfo;
      if (!userInfo) {
        return false
      }
      if (userInfo.companyId !== Number(supplierId)) {
        if (userInfo.loginIdentity === 1) {
          // 供销商身份需要切换成分销商
          const success = await switchIdentity(2);
          const success2 = await loadUserInfo()
          if (success && success2) {
            return '22'
          } else {
            return '0'
          }
        }
        return '22'
      } else {
        return false
      }
    },
    handleLogin() {
      this.$refs.registeDialog.method_close()
      this.$refs.loginDialog.method_open('shop')
    },
    handleRegiste() {
      this.$refs.loginDialog.method_close()
      this.$refs.registeDialog.method_open('shop')
    }
  }
}
</script>
<style lang="scss" scoped>
  $primary: #2695FA;
   .block-header {
      // position: fixed;
      // top: 0;
      box-shadow: 0 2px 5px 0 rgba(0,0,0,0.05);
      height: 50px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 2;
      position: relative;
      padding: 0 18px;
      border-top: 2px solid #2695FA;
      .part-logo {
        width: 180px;
        display: flex;
        align-items: center;
        font-size: 16px;
        img {
          width: 26px;
          height: 26px;
          margin-right: 9px;
        }
    }
  }
.block-body {
  width: 100%;
  height: calc(100% - 50px);
  display: flex;
  padding: 0 20px;
  .block-body-left {
    flex-basis: 180px;
    flex-shrink: 0;
    flex-grow: 0;
    overflow: hidden;
  }
  .block-body-main {
    flex: 1;
    width: calc(100% - 180px);
    overflow-y: auto;
  }
}
</style>
